<template>
  <div class="container" :class="{ warning }">
    <div class="control-header">
      <p v-if="label" class="label">{{ label }}</p>
      <span v-a11y-tab class="clear-button" v-if="showClear" @click="$emit('clear')">{{
        $t('clear')
      }}</span>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: ['warning', 'label', 'showClear'],
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts.scss';
@import '~@/assets/styles/colors.scss';
@import '~@/assets/styles/variables.scss';

.container {
  padding: 8px 12px;
  flex-direction: column;
}

.control-header {
  display: flex;
  margin-bottom: 8px;
}

.clear-button {
  margin-top: -2px;
  color: $blue;
  cursor: pointer;
  font-size: 14px;
  letter-spacing: 0.13px;
  line-height: 16px;
}

.label {
  text-transform: capitalize;
  font-size: $font-size-small;
  font-weight: bold;
  padding-right: 25px;
  letter-spacing: 0.71px;
  line-height: 14px;
}

.warning {
  border: 2px dashed $yellow;
  border-radius: $border-radius;
  background-color: $light-yellow;
}
</style>
